import React from "react";
import Example from "../../intro/Example";
import Instructions from "../../intro/Instructions";
import { FormattedMessage } from "react-intl";

function InstructionsPopOver(props) {
  const { show, assesment, assesmentTest, toggleInstructions } = props;
  const test = assesmentTest.test;

  if (!show) return <></>;
  return (
    <div
      id='instructions-pop-over-wrapper'
      onClick={() => {
        toggleInstructions();
      }}>
      <div id='instructions-pop-over'>
        <div id='instructions-pop-over-body'>
          <Instructions assesment={assesment} assesmentTest={assesmentTest}  />
          <Example test={test} />
        </div>
        <div id='instructions-pop-over-footer'>
          <button
            className='btn btn-default'
            onClick={() => {
              toggleInstructions();
            }}>
            <FormattedMessage id='app.global.button.close' />
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstructionsPopOver;
